import { SharedStoreState } from '../types';

export const selectRegionPicker = (state: SharedStoreState) =>
	state.regionPicker;

export const selectRegionPickerStatus = (state: SharedStoreState) =>
	state.regionPicker.initialized;
